

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const viewInvoiceApi = createAsyncThunk("viewInvoice", async ({
    username,
    commission,
    month,
    year,
    is_deleted,
    isBlocked,
    name,
    totalCommission,
    totalPreTaxAmount,
    totalSilverPreTaxAmount,
    totalGoldPreTaxAmount,
    totalSilverQuantity,
    totalGoldQuantity,
    totalGoldTotalAmount,
    totalSilverTotalAmount,
    totalGoldGst,
    totalSilverGst,
    totalGoldCommission,
    totalSilverCommission
}) => {
    const response = await axiosInstance.post("/generateInvoiceOfPartner",
        {
            username,
            commission,
            month,
            year,
            is_deleted,
            isBlocked,
            name,
            totalCommission,
            totalPreTaxAmount,
            totalSilverPreTaxAmount,
            totalGoldPreTaxAmount,
            totalSilverQuantity,
            totalGoldQuantity,
            totalGoldTotalAmount,
            totalSilverTotalAmount,
            totalGoldGst,
            totalSilverGst,
            totalGoldCommission,
            totalSilverCommission
        }
    );
    return response.data;
});

const viewInvoiceSlice = createSlice({
    name: "viewInvoice",
    initialState: {
        viewInvoice: [],
        errors: [],
        loading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(viewInvoiceApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(viewInvoiceApi.fulfilled, (state, action) => {
                state.viewInvoice = action?.payload;
                state.loading = false;
            })
            .addCase(viewInvoiceApi.rejected, (state, action) => {
                state.errors = action.payload;
                // state.errors.push(action.error.message);
                state.loading = false;
            });
    },
});

export default viewInvoiceSlice.reducer;
